import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { Ng2ScrollimateModule } from 'ng2-scrollimate';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { OrderModule } from 'ngx-order-pipe';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { NgInviewModule } from 'angular-inport';
import { ShareModule } from '@ngx-share/core';
import { NguCarouselModule } from '@ngu/carousel';
// import { SwiperModule, SwiperConfigInterface, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
//
// const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
//   observer: true,
//   direction: 'horizontal',
//   threshold: 50,
//   spaceBetween: 5,
//   slidesPerView: 1,
//   centeredSlides: true
// };

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { JobComponent } from './job/job.component';
import { ReferencesComponent } from './references/references.component';
import { TeamComponent } from './team/team.component';
import { NewsComponent } from './news/news.component';
import { SingleNewsComponent } from './single-news/single-news.component';
import { NewsLinksComponent } from './news-links/news-links.component';
import { ContactComponent } from './contact/contact.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { HeaderComponent } from './partials/header/header.component';
import { FooterComponent } from './partials/footer/footer.component';
import { PerformanceComponent } from './performance/performance.component';
import { DesignComponent } from './design/design.component';
import { ManagementComponent } from './management/management.component';
import { LegalsComponent } from './legals/legals.component';

import { TeamService } from './team/team.service';
import { NewsService } from './news/news.service';
import { ReferencesService } from './references/references.service';

import { ReversePipe } from'./reverse.pipe';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    JobComponent,
    ReferencesComponent,
    TeamComponent,
    NewsComponent,
    SingleNewsComponent,
    NewsLinksComponent,
    ContactComponent,
    ScrollTopComponent,
    HeaderComponent,
    FooterComponent,
    PerformanceComponent,
    DesignComponent,
    ManagementComponent,
    LegalsComponent,
    ReversePipe
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'le-jour-porte-conseil'}),
    OrderModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    ScrollToModule.forRoot(),
    NgxPageScrollModule,
    NgInviewModule,
    Ng2ScrollimateModule,
    BrowserAnimationsModule,
    ShareModule.forRoot(),
    NguCarouselModule
  ],
  providers: [
    TeamService,
    NewsService,
    ReferencesService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts